import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/auth/services/auth.service';
import { Production } from 'src/shared/constants';
import { AuthClient } from 'src/shared/services/api.service';
import { ConfigService } from 'src/shared/services/config.service';

@Component({
  standalone: false,
  selector: 'edportal-account-registration',
  templateUrl: './account-registration.component.html',
  styles: ``,
})
export class AccountRegistrationComponent implements OnInit {
  registrationLink = signal('');

  constructor(
    private readonly authService: AuthService,
    private readonly configService: ConfigService,
    private readonly router: Router,
    private readonly authClient: AuthClient,
  ) {}

  ngOnInit() {
    this.getRegistrationUrl();
  }

  getRegistrationUrl() {
    this.authClient.getADEConnectRegistrationLink().subscribe((x) => {
      this.registrationLink.set(x);
    });
  }

  login() {
    if (this.configService.config.environment !== Production && this.configService.config.testModeAllowed) {
      this.router.navigateByUrl('/launch/selector');
    } else {
      this.authService.login();
    }
  }
}
